 import { axiosInstance } from 'network/apis';

export const loginRequest = async (payload) => {
  return await axiosInstance.post(`login`,payload,  { handlerEnabled: false })
};

export const updatePasswordRequest = async (payload) => {
  return await axiosInstance.post(`/user/${payload.userId}`,{password: payload.password, token: payload.token}, { handlerEnabled: false })
};


function updateAccountSelection (accountId) {
  return axiosInstance.post('salesforce/getSalesforceClientsWithFilter', {projectAccountId: accountId}, { handlerEnabled: true })
}

function isI2andQsToolUser (payload) {
  return axiosInstance.post(`reset-user-password/check-qsTool-i2`, {email: payload.resetPasswordEmail}, { handlerEnabled: false })
}

function sendResetPasswordEmailRequest (payload) {
  return axiosInstance.post(`reset-user-password/send-user-password-email`, {email: payload.resetPasswordEmail}, { handlerEnabled: false })
}

export default {
    loginRequest,
    updatePasswordRequest,
    updateAccountSelection,
    isI2andQsToolUser,
    sendResetPasswordEmailRequest
};
